export default "__VITE_ASSET__UBeMEdlW__"